// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__DhXtw","row":"ProcedureTreatmentSummary_row__3l7bF"};